import * as Yup from 'yup';

export default Yup.object().shape({
  callerId: Yup.string().required(),
});
